module.exports = __webpack_public_path__ + "static/media/devGif.46d4db49.gif";